/* -------------------------------------------------------------------------- *
 * Global Navigation Functionality *
 * -------------------------------------------------------------------------- */

// Show/hide navigation (mobile) on click
let nav_el;

function toggleNav() {
    this.classList.toggle('is-open');
    nav_el.classList.toggle('is-open');
}

// Add a background to the header on scroll
let header_el;

const observer_options = {
    rootMargin: '1px',
};

const observer = new IntersectionObserver((entries) => {
    // Check if the element has been scrolled past
    if (entries[0].isIntersecting === false) {
        // Add the background
        header_el.classList.add('has-scrolled');
    } else {
        // Remove the background
        header_el.classList.remove('has-scrolled');
    }
}, observer_options);

/* ------------- *
 * Module Export *
 * ------------- */

const Nav = {
    init() {
        const button_el = document.querySelector('#js-headerBtn');
        const sentinel_el = document.querySelector('#js-sentinel');

        nav_el = document.querySelector('#js-nav');
        header_el = document.querySelector('#js-header');

        // Show/hide navigation (mobile) on click
        button_el.addEventListener('click', toggleNav);

        // Add a background to the header on scroll
        observer.observe(sentinel_el);
    },
};

export default Nav;
